import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7081fe7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-root",
  id: "kt_app_root"
}
const _hoisted_2 = {
  key: 0,
  class: "connect-as-strip",
  "aria-hidden": "true",
  "data-cy": "connect-as-strip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTContent = _resolveComponent("KTContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isConnectedAs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_KTContent)
  ]))
}